import { ImportJobGqlService } from './data-services/dynamics/importjob-gql.service';
import { SolutionHistoryGqlService } from './data-services/dynamics/solutionhistory-gql.service';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule, APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';


import { HttpClientModule, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule, DatePipe } from '@angular/common';

import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { AppMaterialComponentsModule } from './app-material-components';
import { FlexLayoutModule, FlexModule } from '@ngbracket/ngx-layout';
import { NgxImageCompressService } from 'ngx-image-compress';
import { DeviceDetectorService } from 'ngx-device-detector';

import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing-module';
import { AuthorizationComponent } from './login/authorization.component';
import { LoginComponent } from './login/login.component';
import { ImpersonateComponent } from './login/impersonate.component';
import { ActivateComponent } from './login/activate/activate.component';
import { AppPageComponent } from './chrome/app-page.component';
import { AppFootComponent } from './chrome/app-foot.component';

import { ApplicationHomeComponent } from './grant/application-home.component';
import { ApplicationComponent } from './grant/application.component';
import { RegisteredComponent } from './grant/stage/registered.component';
import { PreretrofitComponent } from './grant/stage/preretrofit.component';
import { PostretrofitComponent } from './grant/stage/postretrofit.component';
import { ReviewComponent } from './grant/stage/review.component';
import { InspectionComponent } from './grant/stage/inspection.component';

import { ReimbursementComponent } from './grant/stage/reimbursement.component';
import { DialogUploadComponent } from './grant/dialog/dialog-upload.component';
import { DialogUploadApplicationBidComponent } from './grant/dialog/dialog-upload-applicationbid.component';
import { DialogUploadReceiptComponent } from './grant/dialog/dialog-upload-receipt.component';
import { DialogViewComponent } from './grant/dialog/dialog-view.component';
import { DialogPermissionComponent } from './grant/dialog/dialog-permission.component';
import { DialogW9formComponent } from './grant/dialog/dialog-w9form.component';
import { DialogPaformComponent } from './grant/dialog/dialog-paform.component';
import { DialogPafWarnComponent } from './grant/dialog/dialog-paform-warn.component';
import { DialogSubmitComponent } from './grant/dialog/dialog-submit.component';
import { DialogContractorProxyComponent } from './grant/dialog/dialog-contractorproxy.component';
import { DialogContractorReviewComponent } from './grant/dialog/dialog-contractorreview.component';
import { DialogContractorReviewListComponent } from './grant/dialog/dialog-contractorreviewlist.component';
import { DialogContractorUnlistedComponent } from './grant/dialog/dialog-contractorunlisted.component';
import { DialogWithdrawComponent } from './grant/dialog/dialog-withdraw.component';
import { DialogZipcodeComponent } from './directory/dialog-zipcode.component';
import { DialogDeleteZipcodeComponent } from './directory/dialog-deletezipcode.component';
import { DialogPermitComponent } from './grant/dialog/dialog-permit.component';
import { DialogActivateCompleteComponent } from './login/activate/dialog-activate-complete.component';
import { DialogConfirmSubmissionComponent } from './grant/dialog/dialog-confirm-submission.component';
import { DialogUploadInspectionFileComponent } from './grant/dialog/dialog-upload-inspection-file.component';
import { DialogConfirmDeleteComponent } from './grant/dialog/dialog-confirm-delete.component';
import { DialogSwitchDashboardComponent } from './grant/dialog/dialog-switch-dashboard.component';

import { PhotoTilesComponent } from './grant/items/photo-tiles.component';
import { FileListComponent } from './grant/items/file-list.component';
import { InspectionFileListComponent } from './grant/items/inspection-file-list.component';

import { ProgramRulesAcknowledgeComponent } from './grant/items/program-rules-acknowledge.component';
import { ReceiptListComponent } from './grant/items/receipt-list.component';
import { FormComponent } from './grant/items/form.component';
import { ContractorFormComponent } from './grant/forms/contractor-form.component';
import { ContractorSgFormComponent } from './grant/forms/contractor-sg-form.component';
import { PermitFormComponent } from './grant/forms/permit-form.component';
import { TimespanFormComponent } from './grant/forms/timespan-form.component';
import { ReceiptFormComponent } from './grant/forms/receipt-form.component';

import { AppSheetContractorComponent } from './chrome/app-sheet-contractor.component';
import { AppSheetHelpComponent } from './chrome/app-sheet-help.component';

import { TrainingComponent } from './training/training.component';
import { ResourcesComponent } from './resources/resources.component';
import { DirectoryComponent } from './directory/directory.component';
import { MaterialComponent } from './material/material.component';
import { ContactEbbComponent } from './contact/contact-ebb.component';
import { LoadingComponent } from './loading/loading.component';
import { NgxCurrencyDirective, provideEnvironmentNgxCurrency } from 'ngx-currency';
import { NgxTrimDirectiveModule } from 'ngx-trim-directive';
import { FilenamePipe } from './pipes/filename.pipe';
import { NgxExtendedPdfViewerModule } from 'ngx-extended-pdf-viewer';

export const customCurrencyMaskConfig = {
  align: 'right',
  allowNegative: true,
  allowZero: true,
  decimal: '.',
  precision: 2,
  prefix: '$ ',
  suffix: '',
  thousands: ',',
  nullable: true,
  min: null,
  max: null,
  inputMode: 0
};

import {
  AuthenticationService,
  OptionSetsApiService,
  ApplicationApiService,
  ApplicationEventApiService,
  ApplicationBidApiService,
  ContractorHireHistoryApiService,
  ApplicationPaymentApiService,
  ApplicationInspectionFileApiService,
  ContactApiService,
  DwellingApiService,
  AnnotationApiService,
  ApprovalTaskItemApiService,
  ContractorReviewApiService,
  ContractorServiceZipApiService,
  PrintApiService,
  ImportJobApiService,
  SolutionHistoryApiService,
  ApplicationTaxRequestApiService,
  CrossSiteNavigationService
} from './data-services/index';

import {
  AppLoadService,
  ContractorApiService,
  ContractorGqlService,
  ZipCodeApiService,
  ZipCodeGqlService,
  ContractorSearchModule,
  CaseApiService,
  CaseGqlService,
  ContactUsModule,
  HelpApiService,
  HelpGqlService,
  DialogSolutionDeployingComponent,
  AdditionalTaskItemApiService,
  AdditionalTaskItemGqlService,
  TraininghModule,
  NotificationApiService,
  NotificationGqlService,
  RecaptchaService,
  AchPaymentApiService,
  AchPaymentGqlService
} from '@ebb-v2/ebb-integration'

import {
  ApplicationGqlService,
  ApplicationPaymentGqlService,
  ApplicationEventGqlService,
  ApplicationBidGqlService,
  ApplicationInspectionFileGqlService,
  ContractorHireHistoryGqlService,
  ApprovalTaskItemGqlService,
  ContactGqlService,
  ContractorServiceZipGqlService,
  DwellingGqlService,
  OptionSetsGqlService,
  ApplicationTaxRequestGqlService
} from './data-services/dynamics/index';
import { EbbInspectionFormComponent } from './grant/forms/ebb-inspection-form.component';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter, MAT_MOMENT_DATE_FORMATS } from '@angular/material-moment-adapter';

import { NewApplicationComponent } from './grant/items/new-application-list.component';
import { OpenApplicationComponent } from './grant/items/open-application-list.component';
import { CloseApplicationComponent } from './grant/items/close-application-list.component';
import { DwellingQualifiedListComponent } from './grant/items/dwelling-qualified-list.component';
import { TaxListComponent } from './grant/items/tax-list.component';
import { DialogtaxrequestformComponent } from './grant/dialog/dialog-taxrequestform.component';
import { DialogConfirmMessageComponent } from './grant/dialog/dialog-confirm-message.component';
import { DialogConfirmIvDeleteComponent } from './grant/dialog/dialog-confirm-iv-delete.component';
import { PermitReceiptSgFormComponent } from './grant/forms/permitreceipt-sg-form.component';
import { DragDirective } from './dragDrop.directive';
import { DialogPortalContractorReviewsComponent } from './grant/dialog/dialog-contractorreviews.component';
import { DialogContractorReviewResponseComponent } from './grant/dialog/dialog-contractorreviewresponse.component';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';

import { IConfig, NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { TrainingEBBComponent } from './training-ebb/training-ebb.component';
import { TrainingESSComponent } from './training-ess/training-ess.component';
import { WithdrawnApplicationComponent } from './grant/items/withdrawn-application-list.component';
import { CompletedApplicationComponent } from './grant/items/completed-application-list.component';
import { LoadingService } from './spinner/loading.service';
import { NotificationComponent } from './notification/notification.component';
import { ReceiptPreretrofitFormComponent } from './grant/forms/receipt-preretrofit-form.component';
import { DialogUploadApplicationEngineeredBidData } from './grant/dialog/dialog-upload-applicationengineeredbid.component';
import { TrainingEMRComponent } from './training-emr/training-emr.component';
import { LdpFormComponent } from './grant/forms/ldp-form.component';
import { DialogLdpUnlistedComponent } from './grant/dialog/dialog-ldpunlisted.component';
import { RECAPTCHA_SETTINGS, RecaptchaModule, RecaptchaSettings } from 'ng-recaptcha-2';
import { ProgramRuleApiService } from './data-services/programrule-api.service';
import { ProgramRuleGqlService } from './data-services/dynamics/programrule-gql.service';
import { DialogPdfReadComponent } from './directory/dialog-pdfread.component';
import { APOLLO_PROVIDERS } from './apollo.config';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MaskLastNDirective } from 'libs/ebb-integration/src/lib/directive/mask-last-n.directive';


export function get_environ_settings(appLoadService: AppLoadService) {
  return () => appLoadService.getEnvironSettings();
}

export const options: Partial<IConfig> | (() => Partial<IConfig>) = {};

@NgModule({ declarations: [
        ActivateComponent,
        LoginComponent,
        ImpersonateComponent,
        AuthorizationComponent,
        AppComponent,
        AppPageComponent,
        AppFootComponent,
        ApplicationHomeComponent,
        ApplicationComponent,
        RegisteredComponent,
        PreretrofitComponent,
        PostretrofitComponent,
        ReviewComponent,
        InspectionComponent,
        ReimbursementComponent,
        AppSheetContractorComponent,
        AppSheetHelpComponent,
        DialogActivateCompleteComponent,
        DialogPermissionComponent,
        DialogUploadComponent,
        DialogUploadApplicationBidComponent,
        DialogUploadApplicationEngineeredBidData,
        DialogViewComponent,
        DialogW9formComponent,
        DialogPaformComponent,
        DialogPafWarnComponent,
        DialogSubmitComponent,
        DialogPermitComponent,
        DialogContractorProxyComponent,
        DialogContractorReviewComponent,
        DialogContractorReviewListComponent,
        DialogPortalContractorReviewsComponent,
        DialogContractorReviewResponseComponent,
        DialogContractorUnlistedComponent,
        DialogLdpUnlistedComponent,
        DialogZipcodeComponent,
        DialogDeleteZipcodeComponent,
        DialogWithdrawComponent,
        DialogConfirmSubmissionComponent,
        DialogUploadReceiptComponent,
        DialogUploadInspectionFileComponent,
        DialogConfirmDeleteComponent,
        DialogSolutionDeployingComponent,
        DialogSwitchDashboardComponent,
        PhotoTilesComponent,
        FileListComponent,
        ReceiptListComponent,
        InspectionFileListComponent,
        ProgramRulesAcknowledgeComponent,
        ContactEbbComponent,
        FormComponent,
        ContractorFormComponent,
        LdpFormComponent,
        ContractorSgFormComponent,
        PermitReceiptSgFormComponent,
        PermitFormComponent,
        TimespanFormComponent,
        ReceiptFormComponent,
        ReceiptPreretrofitFormComponent,
        EbbInspectionFormComponent,
        TrainingComponent,
        TrainingEBBComponent,
        TrainingESSComponent,
        TrainingEMRComponent,
        DirectoryComponent,
        MaterialComponent,
        LoadingComponent,
        ResourcesComponent,
        FilenamePipe,
        NewApplicationComponent,
        OpenApplicationComponent,
        CloseApplicationComponent,
        DwellingQualifiedListComponent,
        TaxListComponent,
        DialogtaxrequestformComponent,
        DialogConfirmMessageComponent,
        DialogConfirmIvDeleteComponent,
        DragDirective,
        WithdrawnApplicationComponent,
        CompletedApplicationComponent,
        NotificationComponent,
        DialogPdfReadComponent,
        
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
     imports: [BrowserModule,
        
        NgxExtendedPdfViewerModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        AppMaterialComponentsModule,
        FlexModule,
        FlexLayoutModule,
        TraininghModule,
        NgxMaskDirective, NgxMaskPipe,
        HttpClientModule,
        ContactUsModule,
        ContractorSearchModule,
        NgxCurrencyDirective,
        NgxTrimDirectiveModule,
        RecaptchaModule, MatFormFieldModule, MatInputModule,MaskLastNDirective
        
        // GuidedTourModule
    ], providers: [
        AppLoadService, provideNgxMask(),provideAnimations(),
        {
            provide: APP_INITIALIZER,
            useFactory: get_environ_settings,
            deps: [AppLoadService],
            multi: true
        },
        {
            provide: RECAPTCHA_SETTINGS,
            useFactory: (appLoadService: AppLoadService): RecaptchaSettings => ({
                siteKey: appLoadService.getRecaptchaKey()
            }),
            deps: [AppLoadService]
        },
        provideEnvironmentNgxCurrency(customCurrencyMaskConfig),
        DeviceDetectorService,
        AuthenticationService,
        { provide: ApplicationApiService, useClass: ApplicationGqlService },
        {
            provide: ApplicationPaymentApiService,
            useClass: ApplicationPaymentGqlService
        },
        {
            provide: ApplicationEventApiService,
            useClass: ApplicationEventGqlService
        },
        { provide: ApplicationBidApiService, useClass: ApplicationBidGqlService },
        {
            provide: ContractorHireHistoryApiService,
            useClass: ContractorHireHistoryGqlService
        },
        { provide: ImportJobApiService, useClass: ImportJobGqlService },
        { provide: SolutionHistoryApiService, useClass: SolutionHistoryGqlService },
        {
            provide: ApplicationInspectionFileApiService,
            useClass: ApplicationInspectionFileGqlService
        },
        {
            provide: ApprovalTaskItemApiService,
            useClass: ApprovalTaskItemGqlService
        },
        { provide: ContactApiService, useClass: ContactGqlService },
        { provide: CaseApiService, useClass: CaseGqlService },
        { provide: ContractorApiService, useClass: ContractorGqlService },
        {
            provide: ContractorServiceZipApiService,
            useClass: ContractorServiceZipGqlService
        },
        { provide: ZipCodeApiService, useClass: ZipCodeGqlService },
        { provide: DwellingApiService, useClass: DwellingGqlService },
        { provide: HelpApiService, useClass: HelpGqlService },
        { provide: AdditionalTaskItemApiService, useClass: AdditionalTaskItemGqlService },
        { provide: OptionSetsApiService, useClass: OptionSetsGqlService },
        { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
        {
            provide: ApplicationTaxRequestApiService,
            useClass: ApplicationTaxRequestGqlService
        },
        { provide: NotificationApiService, useClass: NotificationGqlService },
        { provide: ProgramRuleApiService, useClass: ProgramRuleGqlService },
        { provide: AchPaymentApiService, useClass: AchPaymentGqlService },
        ContractorReviewApiService,
        AnnotationApiService,
        CrossSiteNavigationService,
        PrintApiService,
        NgxImageCompressService,
        DatePipe,
        LoadingService,
        RecaptchaService, ...APOLLO_PROVIDERS,
       
    ], bootstrap: [AppComponent] })
export class AppModule {}
